import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import qs from "qs";
import { IUser } from "../models/User";

interface FetchUserInfoProps {
  user_id: number;
  auth_key: string;
}

export const fetchUserInfo = createAsyncThunk(
  "user/fetchUserInfo",
  async (props: FetchUserInfoProps) => {
    const data = await api.post<IUser>(
      API_ROUTES.ACCOUNT,
      qs.stringify({ ...defaultOptions(), ...props })
    );

    return data;
  }
);
